import { CanActivateFn } from '@angular/router';
import { MetadataLoadingStage, UserContextService } from '../services/user-context.service';
import { SharedService } from '../services/shared-service';
import { inject } from '@angular/core';
import { filter, map, switchMap } from 'rxjs';

export const SubscriptionGuard: CanActivateFn = (route, state) => {
  // Inject the required services
    const userContextService = inject(UserContextService);
    const sharedService = inject(SharedService);
  
    return sharedService.appInitialized$.pipe(
      filter((initialized) => initialized), // Wait for appInitialized$ to emit true
      switchMap(() => userContextService.MetadataLoadingStage$), // Check if organization data is loaded
      filter((loaded) => loaded >= MetadataLoadingStage.SubscriptionsLoaded), // Ensure organization data is fully loaded
      map(() => true) // Allow route activation
    );
};
